import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, useMediaQuery, useTheme } from '@mui/material'

import { Filter } from 'src/components/filter'
import { TableView } from './table-view'
import { GridView } from './grid-view'
import { InviteButton } from './invite-button.component'
import { NavButtons } from './nav-buttons'
import { useAccountUsers } from 'src/hooks'

import { sortToObject } from 'src/common/utils'
import { useOwnerTransferModalProps } from './hooks'
import { accountUsersSortOptions } from './utils'
import { IFilter } from 'src/components/filter/types/filter.types'
import { Loader } from 'src/components/loader'

const AccountUsers = () => {
  const [t] = useTranslation()
  const [filter, setFilter] = useState<IFilter>({ query: '' })
  const [sort, setSort] = useState('user.email-desc')
  const { data, isLoading } = useAccountUsers({ ...filter, ...sortToObject(sort) })
  const theme = useTheme()
  const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))
  const { handleClose, open, handleOpen } = useOwnerTransferModalProps()

  return (
    <div>
      <Filter
        searchFieldText={t('account-users-search-input-placeholder.v')}
        filter={filter}
        setFilter={setFilter}
        sort={sort}
        setSort={setSort}
        selectionOptions={[]}
        sortOptions={accountUsersSortOptions}
        initialState={{ query: '' }}
      />
      <NavButtons handleOpen={handleOpen} handleClose={handleClose} open={open} />
      {isLoading && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            m: '30px',
          }}
        >
          <Loader isStatic />
        </Box>
      )}
      {!isLoading &&
        (isTablet ? (
          <GridView data={data} />
        ) : (
          <TableView data={data} sort={sort} setSort={setSort} />
        ))}
      {!isLoading && <InviteButton handleVerifyOpen={handleOpen} />}
    </div>
  )
}

export { AccountUsers }
